import usePathChanged from './usePathChanged';

export default usePathChanged;
